import { render, staticRenderFns } from "./UsuarioFornecedorDadosSensiveis.vue?vue&type=template&id=8a017862&lang=html"
import script from "./UsuarioFornecedorDadosSensiveis.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorDadosSensiveis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports